import React from "react";
import PropTypes from "prop-types";
import PublicationLinks from "../../Publications/components/PublicationLinks";

function PubmedLink({ match }) {
  const pubId = (match || "").replace(/%%PUBMED:\s*/, "").replace(/%%/, "");
  return (
    <PublicationLinks
      className="tw-inline-block tw-cursor-pointer"
      ids={[pubId]}
    >
      <div className="tw-text-primary">{pubId}</div>
    </PublicationLinks>
  );
}

PubmedLink.propTypes = {
  match: PropTypes.string,
};

PubmedLink.defaultProps = {
  match: "",
};

export default React.memo(PubmedLink);
